<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
    <div class="text-center px-6">
        <!-- Logo Fakturnia -->
        <div class="mb-8">
            <img src="assets/images/logo_full_size.png" alt="Fakturnia" class="h-10 w-auto mx-auto opacity-80">
        </div>

        @if (isLoading) {
            <!-- Karta logowania -->
            <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 max-w-sm mx-auto">
                <!-- Logo Google z animacją -->
                <div class="relative mb-6">
                    <div class="w-20 h-20 mx-auto bg-white rounded-full shadow-lg flex items-center justify-center animate-pulse">
                        <img src="assets/images/others/g-logo.png" alt="Google" class="h-10 w-10">
                    </div>
                    <!-- Kółko ładowania wokół logo -->
                    <div class="absolute inset-0 flex items-center justify-center">
                        <div class="w-24 h-24 border-4 border-transparent border-t-primary-500 rounded-full animate-spin"></div>
                    </div>
                </div>

                <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    @if (success) {
                        Zalogowano pomyślnie! 🎉
                    } @else {
                        Logowanie przez Google
                    }
                </h2>
                
                <p class="text-gray-500 dark:text-gray-400 mb-4">
                    @if (success) {
                        Przekierowuję do panelu...
                    } @else {
                        Weryfikuję Twoje dane...
                    }
                </p>

                <!-- Pasek postępu -->
                <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 overflow-hidden">
                    <div class="bg-gradient-to-r from-blue-500 via-primary-500 to-purple-500 h-1.5 rounded-full animate-progress"></div>
                </div>
            </div>

            <!-- Trust badges -->
            <div class="mt-8 flex items-center justify-center gap-6 text-sm text-gray-400">
                <div class="flex items-center gap-1.5">
                    <svg class="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    </svg>
                    <span>Bezpieczne połączenie</span>
                </div>
                <div class="flex items-center gap-1.5">
                    <svg class="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
                    </svg>
                    <span>Dane chronione</span>
                </div>
            </div>

        } @else if (error) {
            <!-- Karta błędu -->
            <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 max-w-sm mx-auto">
                <div class="w-16 h-16 mx-auto bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-6">
                    <svg class="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>

                <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    Coś poszło nie tak
                </h2>
                
                <p class="text-gray-500 dark:text-gray-400 mb-6">
                    {{ error }}
                </p>

                <button 
                    (click)="goToLogin()" 
                    class="w-full flex items-center justify-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-xl transition-colors">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                    </svg>
                    <span>Powrót do logowania</span>
                </button>
            </div>
        }
    </div>
</div>

<style>
    @keyframes progress {
        0% { width: 0%; margin-left: 0%; }
        50% { width: 60%; margin-left: 20%; }
        100% { width: 0%; margin-left: 100%; }
    }
    .animate-progress {
        animation: progress 1.5s ease-in-out infinite;
    }
</style>
